import * as monaco from 'monaco-editor';
import {
  DefinitionRequest,
  ProtocolConnection,
  ServerCapabilities,
} from 'vscode-languageserver-protocol';

import {
  locationLinkMapper,
  locationMapper,
  positionMapping,
} from '../utils/convertVscodeToMonaco';

export function definitionProvider(
  languageId: string,
  connection: ProtocolConnection,
  definitionOptions: ServerCapabilities['definitionProvider'],
) {
  // TODO: do we want to do anything with definitionOptions.workDoneProgress?
  if (definitionOptions === undefined || definitionOptions === false) return;

  monaco.languages.registerDefinitionProvider(languageId, {
    async provideDefinition(model, position, token) {
      const result = await connection.sendRequest(
        DefinitionRequest.type,
        {
          textDocument: { uri: model.uri.toString(true) },
          position: positionMapping.monacoToVscode(position),
        },
        token,
      );

      if (token.isCancellationRequested || !result) {
        return null;
      }

      if (!Array.isArray(result)) {
        return locationMapper.vscodeToMonaco(result);
      }

      return result.map((location) => {
        if ('uri' in location) {
          return locationMapper.vscodeToMonaco(location);
        } else {
          return locationLinkMapper.vscodeToMonaco(location);
        }
      });
    },
  });
}
